/**
 * Builds the auth header for direct server-to-server calls to Kong-gated APIs
 * (Lantern teaser delivery, and anything else behind the same gateway).
 * The token lives in server-only config (`_dnmgAuthToken`), so the header is
 * omitted on the client — those requests go via the local `/api/*` proxy and
 * must never carry the upstream credential into the browser.
 */
export function kongApiAuthHeader (token?: string): Record<string, string> | undefined {
  return import.meta.server && token ? { 'x-dnmg-auth': `Bearer ${token}` } : undefined;
}
